import { html } from 'lit';

export const soundIcon = html`
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 12v8a1 1 0 0 0 1 1h7l6.6 6.6a2 2 0 0 0 3.4-1.4V5.8a2 2 0 0 0-3.4-1.4L20 6l-5 5H8a1 1 0 0 0-1 1z"/>
</svg>
`